// import dei pacchetti
import { createContext, useEffect, useReducer } from "react";
import { autenticazione } from "../firebase/config";

// creiamo il context
export const AuthContext = createContext();

// funzione per gestire i vari casi derivanti dal dispatch
export const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return { ...state, user: action.payload };
    case "LOGOUT":
      return { ...state, user: null };
    case "AUTH_IS_READY":
      return { ...state, user: action.payload, authIsReady: true };
    default:
      return state;
  }
};

// il provider del context che va a racchiurere tutto l'elemento app sul file index.js
export const AuthContextProvider = ({ children }) => {
  // utilizzando useReducer passiamo come primo argomento la funzione che andrà a gestire lo state
  // come secondo argomento lo state stesso.
  const [state, dispatch] = useReducer(authReducer, {
    user: null,
    authIsReady: false,
  });

  useEffect(() => {
    const unSub = autenticazione.onAuthStateChanged((user) => {
      if (user) {
        user.getIdTokenResult().then((idTokenResult) => {
          user.admin = idTokenResult.claims.admin;
        });
      }
      dispatch({ type: "AUTH_IS_READY", payload: user });
      unSub();
    });
  }, []);

  console.log("AuthContext state:", state);

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
